import { render, staticRenderFns } from "./ChuyouXingweiFenxiDetail.vue?vue&type=template&id=f527a3fa&scoped=true&"
import script from "./ChuyouXingweiFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./ChuyouXingweiFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChuyouXingweiFenxiDetail.vue?vue&type=style&index=0&id=f527a3fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f527a3fa",
  null
  
)

export default component.exports